<template>
  <div class="modal-card" style="width: auto">
    <header class="modal-card-head">
      <p class="modal-card-title">{{ $t("items.favorite.title") }}</p>
    </header>
    <form @submit.prevent="pressed">
      <section>
        <article v-if="error" class="message is-danger">
          <div class="message-body">
            {{ error }}
          </div>
        </article>
      </section>

      <section class="modal-card-body">
        <p class="subtitle">
          {{ $t("items.favorite.description") }}
        </p>

        <b-checkbox v-model="bids">{{ $t("items.favorite.bid") }}</b-checkbox
        ><br />
        <b-checkbox v-model="readyForSale">{{
          $t("items.favorite.readyForSale")
        }}</b-checkbox>
      </section>
      <footer class="modal-card-foot">
        <button class="button" type="button" @click="$parent.close()">
          {{ $t("general.close") }}
        </button>
        <button class="button is-primary">{{ $t("general.save") }}</button>
      </footer>
    </form>
  </div>
</template>

<script>
export default {
  props: ["itemId"],

  data() {
    return {
      bids: false,
      readyForSale: false,
      error: ""
    };
  },
  methods: {
    pressed() {
      this.$axios
        .post(`${window.apiURL}/profile/itemFavorites`, {
          id: this.itemId,
          bids: this.bids,
          readyForSale: this.readyForSale
        })
        .then(response => {
          if (response.status == 200 && response.data.success) {
            this.$buefy.toast.open({
              message: this.$t("items.favorite.saveSuccess"),
              type: "is-success"
            });
            this.$emit("close");
          } else {
            this.error = response.data.message;
          }
        })
        .catch(() => {
          this.error = this.$t("items.favorite.saveError");
        });
    }
  }
};
</script>

<style lang="scss"></style>
